import { Injectable, isDevMode } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpResponse } from '@angular/common/http';

// RxJs
import { catchError, filter, finalize, Observable, tap, throwError } from 'rxjs';

// NgRX
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers';
import { NetworkActions } from '@core/store/actions/network.actions';

// ENVs
import { environment as ENV } from '@environments/environment';



@Injectable()
export class NetworkInterceptor implements HttpInterceptor {

  private clone!: HttpRequest<unknown>;
  private csrfToken: string;


  constructor(
    private readonly store: Store<AppState>
  ) {
    this.csrfToken = '';
  }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.clone = request.clone({
      // withCredentials: this.needCredentials(request.url),
      // ...this.needCredentials(request.url) && { setParams: { observe: 'response' } },
      setHeaders: {
        // ...!!this.csrfToken && { 'x-xsrf-token': `${ this.csrfToken }` },
        ...!this.isLoadFileUrl(request.url) && { 'Content-Type': 'application/json; text/plain;' },
      }
    });

    !request.url.includes(ENV.DEPRECIATION.STORE.UPDATE) && this.store.dispatch(NetworkActions.load());

    return next.handle(this.clone).pipe(
      filter(res => res instanceof HttpResponse),
      tap((resp) => {
        this.getCSRFToken(resp as HttpResponse<any>);
        this.store.dispatch(NetworkActions.success({
          petition: {
            statusCode: (resp as any).status,
            requestMethod: this.clone.method,
            requestURL: this.clone.urlWithParams,
            error: null
          }
        }));
      }),
      catchError((err) => {
        this.store.dispatch(NetworkActions.error({
          petition: {
            statusCode: (err as any).status,
            requestMethod: this.clone.method,
            requestURL: this.clone.urlWithParams,
            error: (err as any).message
          }
        }));
        return throwError(err);
      })
    );
  }


  private getCSRFToken(resp: HttpResponse<any>): void {
    try {
      if (!!resp.headers.get('sod-warranty-csrf-token')) {
        this.csrfToken = resp.headers.get('sod-warranty-csrf-token') || '';
        isDevMode() && console.log({ resp, sodCsrfToken: resp.headers.get('sod-warranty-csrf-token') });
      }
    } catch (err) { isDevMode() && console.warn({ err }); }
  }


  private needCredentials(url: string): boolean {
    return url.includes(ENV.WARRANTY.RECOVERY.EXPORT_CONTRACTS_TO_EXCEL);
  }


  private isLoadFileUrl(url: string): boolean {
    const patterns: string[] = [
      ENV.DEPRECIATION.STEPPER.THIRD_STEP.UPDATE_CAF,
      ENV.DEPRECIATION.STEPPER.SECOND_STEP.LOAD_SKU
    ];

    return patterns.some(pattern => url.includes(pattern));
  };
}
